export function replaceOrAppend<T>(arr: T[], item: T, predicate: (item: T) => boolean): T[] {
  const index = arr.findIndex(predicate)
  if (index === -1) return [...arr, item]
  return [...arr.slice(0, index), item, ...arr.slice(index + 1)]
}
